export const getLocalStorageValue = (fieldName: string) => {
  if (
    !!fieldName &&
    fieldName.length > 0 &&
    window.localStorage &&
    !!window.localStorage.getItem(fieldName)
  ) {
    const localStorageValue = window.localStorage.getItem(fieldName);
    try {
      if (!!localStorageValue) {
        return localStorageValue;
      }
    } catch (err) {
      console.warn(err);
    }
  }
  return "";
};
